import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Img1 from "./img/img_us/US_ACOUSTIC.webp";
import Img2 from "./img/img_us/US_ACOUSTIC_2.webp";
import Img3 from "./img/img_us/US_LEVEL.webp";
import Img4 from "./img/webp/27Cabine acoustique design pour bureau open space – isolation phonique et confort acoustique.webp";


const USAcousticSection = () => {

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div className="usstretch-section">

      {/* ===== BLOC 1 ===== */}
      <div className="usstretch-row">
        <div className="usstretch-text">
          <h3 data-aos="fade-right">
            <span className="subtitle-us">US</span> ACOUSTIC
          </h3>
          <br />
          <h5 data-aos="fade-up">Avec des propriétés techniques</h5>

          <p data-aos="fade-up">
            Large gamme de textiles acoustiques développés spécialement pour
            l’architecture. Textiles en polyester tissé ou tricoté en très grandes
            largeurs (plus de 5 m), associés à des molletons acoustiques ou à des
            panneaux de laine minérale de 10 à 40 mm.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🔊 Très hautes performances d’absorption acoustique</li>
            <li>⚡ Rapidité de mise en œuvre</li>
            <li>🌱 Écologie – démarche HQE</li>
            <li>🏗️ Adapté aux projets architecturaux exigeants</li>
            <li>🛠️ Solution durable et professionnelle</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/feutrine-acoustique-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>

        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img1} alt="US Acoustic propriétés techniques" />
        </div>
      </div>

      {/* ===== BLOC 2 (inversé) ===== */}
      <div className="usstretch-row">
        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img2} alt="US Acoustic toiles acoustiques AW" />
        </div>

        <div className="usstretch-text">
          <h3 data-aos="fade-up-right">
            <span className="subtitle-us">US</span> ACOUSTIC
          </h3>
          <br />
          <h5 data-aos="fade-up">Toiles acoustiques AW</h5>

          <p data-aos="fade-up">
            Les toiles acoustiques AW apportent un réel confort acoustique.
            Elles permettent de réaliser des formes, des baffles ou des panneaux
            assurant de très hautes performances d’absorption sonore.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🎧 Idéales pour corriger les problèmes d’échos</li>
            <li>📊 Taux d’absorption élevé (αw ≈ 65 %)</li>
            <li>🏢 Adaptées aux espaces publics et professionnels</li>
            <li>⚡ Mise en œuvre rapide et propre</li>
            <li>🌿 Amélioration de la qualité de vie</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/acoustique-toile-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>
      </div>

      {/* ===== BLOC 3 ===== */}
      <div className="usstretch-row">
        <div className="usstretch-text">
          <h3 data-aos="fade-right">
            <span className="subtitle-us">US</span> LEVEL
          </h3>
          <br />
          <h5 data-aos="fade-up">Panneaux acoustiques</h5>

          <p data-aos="fade-up">
            Panneaux acoustiques en feutre PET composés d’au moins 50 % de
            bouteilles plastiques recyclées. Solutions durables et polyvalentes
            pour le traitement acoustique mural, plafond ou mobilier.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>♻️ Matériau recyclé et écologique</li>
            <li>📐 Épaisseurs disponibles de 10 à 40 mm</li>
            <li>🎨 Large choix de couleurs et de formes</li>
            <li>🔇 Absorption sonore optimale</li>
            <li>🏠 Adaptés à de nombreuses applications</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/panneau-acoustique-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>

        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img3} alt="US Level panneaux acoustiques" />
        </div>
      </div>
      {/* ===== BLOC 4 – US ACOUSTIC CABINE ===== */}
<div className="usstretch-row reverse">

  

  <div className="usstretch-text">
    <h3 data-aos="fade-up-right">
      <span className="subtitle-us">US</span> CABINE POD
    </h3>
    <br />
    <h5 data-aos="fade-up">Cabine acoustique</h5>

    <p data-aos="fade-up">
      Les cabines acoustiques US Acoustic offrent une solution idéale pour
      créer des espaces isolés phoniquement au sein d’environnements ouverts.
      Elles permettent de travailler, téléphoner ou se réunir en toute
      confidentialité avec un confort acoustique optimal.
    </p>

    <h6 data-aos="fade-up">Avantages :</h6>
    <ul data-aos="fade-up">
      <li>🔇 Isolation phonique haute performance</li>
      <li>🏢 Idéales pour open spaces et bureaux modernes</li>
      <li>🧩 Design élégant et personnalisable</li>
      <li>⚡ Installation rapide et modulaire</li>
      <li>🌿 Amélioration du bien-être au travail</li>
    </ul>

    <a
      data-aos="fade-up"
      href="/cabine-acoustique-maroc"
      className="learn-more-link"
    >
      En savoir plus <span className="arrow">→</span>
    </a>
  </div>
<div
    className="usstretch-image"
    data-aos="fade-up"
    data-aos-duration="3000"
  >
    <img src={Img4} alt="US Acoustic Cabine acoustique" />
  </div>
</div>


    </div>
  );
};

export default USAcousticSection;
